import { cva } from '@agapi/ui/panda/css';

export const badgeStyles = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    borderRadius: '50%',
    maskImage: 'radial-gradient(circle, white 100%, black 100%)',
    WebkitMaskImage: 'radial-gradient(circle, white 100%, black 100%)',
    textAlign: 'center',
  },
  variants: {
    size: {
      sm: {
        width: 'items.md',
        height: 'items.md',
        fontSize: 'sm',
        padding: '2',
      },
      md: {
        width: 'items.xl',
        height: 'items.xl',
        fontSize: 'md',
        padding: '3',
      },
      lg: {
        width: 'items.2xl',
        height: 'items.2xl',
        fontSize: 'md',
        padding: '4',
        md: {
          width: 'items.3xl',
          height: 'items.3xl',
          fontSize: 'lg',
          padding: '4',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});